import { useState } from 'react';
import { Game } from 'shared/lib/core';
import { Hallmap } from 'entities/hallmap';
import { DashboardContainer } from 'widgets/dashboardContainer';
import { OrderInfoProvider } from 'entities/orders';

export const HallmapEditor = () => {
	const [, setHallmap] = useState<Game | undefined>();

	return (
		<DashboardContainer>
			<OrderInfoProvider>
				<Hallmap setHallmap={setHallmap} mode="editor" order={null} />

			</OrderInfoProvider>
		</DashboardContainer>
	);
};
